/**
 * @license
 * Copyright (c) 2011 %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

/**
 * Log level none (least verbose)
 */
export const NONE = 0;
/**
 * Log level error
 */
export const ERROR = 1;
/**
 * Log level warn
 */
export const WARN = 2;
/**
 * Log level info
 */
export const INFO = 3;
/**
 * Log level log
 */
export const LOG = 4;
